const PERM_FORMAT = Object.freeze({
  checkbox: 'single-checkbox',
  radio: 'radio-buttons',
});

export default PERM_FORMAT;
